module.exports = __webpack_public_path__ + "static/media/eastBallaratGig.63d60dcf.jpeg";